import pathify from 'vuex-pathify'
import createPersistedState from 'vuex-persistedstate'

import site from './vuex-modules/site.js'

export default function({ store }) {
  pathify.options.deep = 2
  pathify.plugin(store)

  const options = {
    preserveState: false
  }

  if (typeof store == undefined) {
    console.warn('Vuex store not detected')
  }

  store.registerModule('site', site, options)

  if (process.client) {
    const sessionPaths = []
    const storagePaths = Object.keys(store.state || {}).filter(mod => !sessionPaths.includes(mod))

    if (sessionPaths.length) {
      const session = createPersistedState({
        storage: window.sessionStorage,
        paths: sessionPaths
      })

      session(store)
    }

    if (storagePaths.length) {
      const storage = createPersistedState({
        storage: window.localStorage,
        paths: storagePaths
      })

      storage(store)
    }
  }
}
